<template lang="pug">
  .wardrobe-materials
    vue-good-table(
      :columns="columns"
      :rows="materials"
    )
      template(slot="table-row" slot-scope="props")
        span(v-if="props.column.field == 'materialAmount'")
          | {{ props.row.materialAmount | float }}
        span(v-else-if="props.column.field == 'materialAmountFull'")
          | {{ props.row.materialAmountFull | float }}
        span(v-else-if="props.column.field == 'materialPrice'")
          | {{ props.row.materialPrice | currency }}
        span(v-else-if="props.column.field == 'wasteCoeff'")
          | {{ props.row.wasteCoeff | toPercent }}
        span(v-else-if="props.column.field == 'priceCost'")
          | {{ props.row.priceCost | currency }}
</template>

<script>
export default {
  props: {
    materials: {
      required: true,
      type: Array
    }
  },

  data() {
    return {
      columns: [
        {
          label: 'Материал',
          field: 'materialName',
          sortable: false
        },
        {
          label: 'Единица измерения',
          field: 'unitName',
          sortable: false
        },
        {
          label: 'Общее кол-во БЕЗ запаса',
          field: 'materialAmount',
          type: 'number',
          sortable: false
        },
        {
          label: 'Запас на отходы,%',
          field: 'wasteCoeff',
          type: 'number',
          sortable: false
        },
        {
          label: 'Общее кол-во С УЧЕТОМ запаса на отходы',
          field: 'materialAmountFull',
          type: 'number',
          sortable: false
        },
        {
          label: 'Цена БЕЗ наценки, руб.',
          field: 'materialPrice',
          type: 'number',
          sortable: false
        },
        {
          label: 'Сумма БЕЗ наценки, руб.',
          field: 'priceCost',
          type: 'number',
          sortable: false
        }
      ]
    };
  }
};
</script>
